var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 10.5C12.4142 10.5 12.75 10.8358 12.75 11.25V17.1094C12.75 17.5236 12.4142 17.8594 12 17.8594C11.5858 17.8594 11.25 17.5236 11.25 17.1094V11.25C11.25 10.8358 11.5858 10.5 12 10.5ZM12 6.75C11.5858 6.75 11.25 7.08579 11.25 7.5C11.25 7.91421 11.5858 8.25 12 8.25H12.01C12.4242 8.25 12.76 7.91421 12.76 7.5C12.76 7.08579 12.4242 6.75 12.01 6.75H12Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-circle.347acdeb22f9e432332d5e6e640afcb7.svg";